import customizeGameImage from 'assets/images/games/customizethegame.png'
import embedGameImage from 'assets/images/games/embedthegame.png'
import pickAGameImage from 'assets/images/games/pickagame.png'
import { buildTranslate } from 'locales'
import { Container, Row } from 'react-bootstrap-five'
import { merchantTheme } from 'theme'
import ContentHeader from './ContentHeader'
import GameFeatureCard from './GameFeatureCard'
import GamesCallToAction from './GamesCallToAction'

const t = buildTranslate('games')

const GamesDisabled = () => {
  const { colors } = merchantTheme

  return (
    <Container className="pl-0">
      <div className="mt-xl mb-xxl">
        <ContentHeader
          title={t('disabled.title')}
          description={t('disabled.description')}
        />

        <Row className="mb-xl">
          <GameFeatureCard
            imageSrc={pickAGameImage}
            imageAlt="Game selection"
            title={t('disabled.features.pickGame.title')}
            backgroundColor={colors.eggYolk10}
          />
          <GameFeatureCard
            imageSrc={customizeGameImage}
            imageAlt="Game customization"
            title={t('disabled.features.customize.title')}
            backgroundColor={colors.belizeHole10}
          />
          <GameFeatureCard
            imageSrc={embedGameImage}
            imageAlt="App integration"
            title={t('disabled.features.embed.title')}
            backgroundColor={colors.spearmint10}
            className=""
          />
        </Row>

        <GamesCallToAction />
      </div>
    </Container>
  )
}

export default GamesDisabled
